import AdminApi from '../../services/api'
import swal from 'sweetalert2'
import session from "../../services/session"
import CONFIG_COMPANY from "../../services/myConfig"
import Loc from "../../services/localization"

const AdminApiService = new AdminApi()
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            role: '',
            items: [],
            filter: '',
            fromDate: null,
            toDate: null,
        }
    },
    computed: {
        filteredItems: function () {
            const query = (this.filter || '').toLowerCase()
            return this.items.filter(item =>
                (item.name || '').toLowerCase().indexOf(query) !== -1 ||
                (item.note || '').toLowerCase().indexOf(query) !== -1
            )
        }
    },
    methods: {
        load: load,
        editItem: editItem,
        addItem: addItem,
        formatDateAndTime: formatDateAndTime,
        keymonitor: keymonitor
    },
    beforeMount() {
        if (session.getRole() !== 'ROLE_SUPER_ADMIN' && session.getRole() !== 'ROLE_ADMIN') {
            this.$router.push(CONFIG_COMPANY.HOME)
            return
        }
        this.fromDate = this.$moment(new Date()).format('YYYY-MM-DD')
        this.toDate = this.$moment(new Date()).format('YYYY-MM-DD')
        this.role = session.getRole()
        this.load()
    },
    watch: {
        'fromDate': function (newVal) {
          this.load();
        },
        'toDate': function (newVal) {
            this.load();
        }
    }
}

function load() {
    let _self = this
    let params = {
        from: _self.$moment(_self.fromDate).format('DD-MM-YYYY'),
        to: _self.$moment(_self.toDate).format('DD-MM-YYYY')
    }
    AdminApiService.getWarehouseShopItems(params)
        .then((response) => {
            _self.items = response.data
        })
        .catch(error => {
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function keymonitor(event) {
    if (event.key === 'Enter') {
        this.load()
    }
}

function editItem(item) {
    this.$router.push('/add-warehouse-shop-item?id=' + item.id)
}

function addItem() {
    this.$router.push('/add-warehouse-shop-item')
}

function  formatDateAndTime(date){
    return this.$moment(new Date(date * 1000)).format('DD-MM-YYYY HH:mm')
}



// WEBPACK FOOTER //
// ./src/components/Warehouse/WarehouseShopItem.js